import { render, staticRenderFns } from "./Etapa10.vue?vue&type=template&id=940c3f6c&scoped=true"
import script from "./Etapa10.vue?vue&type=script&lang=js"
export * from "./Etapa10.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=940c3f6c&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa10.vue?vue&type=style&index=1&id=940c3f6c&prod&lang=css"
import style2 from "./Etapa10.vue?vue&type=style&index=2&id=940c3f6c&prod&lang=scss"
import style3 from "./Etapa10.vue?vue&type=style&index=3&id=940c3f6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940c3f6c",
  null
  
)

export default component.exports